var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDvrStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.179,
    height: 28.712,
    viewBox: "0 0 30.179 28.712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2537"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 893",
    d: "M848.612 88.282a.721.721 0 0 1 .393.738Q849 96.9 849 104.79c0 .56-.174.73-.739.73H819.57c-.566 0-.739-.17-.739-.73V89.02a.72.72 0 0 1 .393-.738zm-14.7.539h-13.731c-.66 0-.813.152-.813.811v14.544c0 .658.152.807.816.807h27.469c.662 0 .813-.151.813-.811V89.628c0-.657-.153-.808-.816-.808z",
    transform: "translate(-818.827 -88.282)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 894",
    d: "M833.941 422.648h-14.275c-.645 0-.8-.15-.8-.793v-4.888c0-.616.17-.787.781-.787h28.609c.612 0 .781.17.782.786v4.918c0 .6-.164.765-.765.765zm-5.915-1.079h7.374c.521 0 .708-.185.709-.7v-2.849c0-.575-.181-.76-.748-.76H820.7c-.574 0-.751.177-.753.754v2.789c0 .605.163.768.762.768zm17.253-3.22a1.609 1.609 0 1 0 3.217-.019 1.609 1.609 0 1 0-3.217.019zm-4.864-1.076h-1.049v1.037h1.049zm1.1 1.044h1.039v-1.04h-1.039zm-1.1 2.2h-1.05v1.029h1.05zm1.108-.009v1.047h1.036v-1.047z",
    transform: "translate(-818.866 -396.094)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 895",
    d: "M1026.965 363.195v-2.647h2.131v2.647z",
    transform: "translate(-1012.946 -343.21)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 896",
    d: "M869.186 528.4h1.838c-.078.324-.146.634-.232.938a.22.22 0 0 1-.163.124c-.387.011-.774.006-1.176.006z",
    transform: "translate(-865.794 -500.754)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 897",
    d: "M1189.225 528.409h1.838l-.266 1.066c-.4 0-.786.005-1.173-.006a.22.22 0 0 1-.165-.121 18.667 18.667 0 0 1-.234-.939z",
    transform: "translate(-1164.277 -500.764)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 898",
    d: "M843.15 119.048v-6.425h12.893v6.425z",
    transform: "translate(-841.512 -110.984)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 899",
    d: "M1064.071 119.083h-12.888v-6.431h12.888z",
    transform: "translate(-1035.533 -111.011)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 900",
    d: "M843.073 231.019V224.6h12.894v6.421z",
    transform: "translate(-841.44 -215.416)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 901",
    d: "M1063.928 231.106h-12.9v-6.421h12.9z",
    transform: "translate(-1035.386 -215.498)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 902",
    d: "M865.08 448.547v2.11h-13.986v-2.11z",
    transform: "translate(-848.921 -426.281)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 903",
    d: "M1227.563 440.294a.539.539 0 0 1 .523.541.527.527 0 1 1-1.054-.009.535.535 0 0 1 .531-.532z",
    transform: "translate(-1199.538 -418.584)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDvrStatus);
export default __webpack_public_path__ + "static/media/DVR_status.f5d1e0cf2a7a2d7b88f71072e3dc5a0e.svg";
export { ForwardRef as ReactComponent };